import React from "react";
import { Link } from "react-router-dom";
import Logo from "../Logo";
import "./Header.css";
import { FormattedMessage } from "react-intl";
import Dropdown from "react-multilevel-dropdown";

class Header extends React.Component {
  render() {
    return (
      <header className="Header">
        <div className="Header-container">
          <Logo />
          <nav className="Header-navbar">
            <ul className="Header-list">
              <li className="Header-item">
                <Dropdown
                  buttonClassName="Header-link Header-link-dropdown"
                  title="La prueba"
                >
                  <Dropdown.Item className="dropdown-item">
                    <Link className="Header-link" to="/etapas">
                      Etapas
                    </Link>
                  </Dropdown.Item>
                  <Dropdown.Item className="dropdown-item">
                    <Link className="Header-link" to="/categorias">
                      Categorías
                    </Link>
                  </Dropdown.Item>
                  <Dropdown.Item className="dropdown-item">
                    <Link className="Header-link" to="/tarifas">
                      Tarifas
                    </Link>
                  </Dropdown.Item>
                  <Dropdown.Item className="dropdown-item">
                    <Link className="Header-link" to="/seguro-devolucion">
                      Seguro de devolución
                    </Link>
                  </Dropdown.Item>
                  <Dropdown.Item className="dropdown-item">
                    <Link className="Header-link" to="/reglamento">
                      Reglamento
                    </Link>
                  </Dropdown.Item>
                  <Dropdown.Item className="dropdown-item">
                    <Link className="Header-link" to="/preguntas-frecuentes">
                      Preguntas frecuentes
                    </Link>
                  </Dropdown.Item>
                </Dropdown>
              </li>
              <li className="Header-item">
                <Dropdown
                  buttonClassName="Header-link Header-link-dropdown"
                  title="Multimedia"
                >
                  <Dropdown.Item className="dropdown-item">
                    <Link className="Header-link" to="/fotos">
                      Fotos
                    </Link>
                  </Dropdown.Item>
                  <Dropdown.Item className="dropdown-item">
                    <Link className="Header-link" to="/videos">
                      Vídeos
                    </Link>
                  </Dropdown.Item>
                </Dropdown>
              </li>
              <li className="Header-item">
                <Link className="Header-link" to="/alojamiento">
                  Alojamiento
                </Link>
              </li>
              <li className="Header-item">
                <Dropdown
                  buttonClassName="Header-link Header-link-dropdown"
                  title="Nuestras pruebas"
                >
                  <Dropdown.Item className="Header-link">
                    Pruebas Global
                    <Dropdown.Submenu>
                      <Dropdown.Item className="dropdown-item">
                        <a
                          className="Header-link"
                          href="http://www.laroadpontevedra.com/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          La Road Pontevedra
                        </a>
                      </Dropdown.Item>
                      <Dropdown.Item className="dropdown-item">
                        <a
                          className="Header-link"
                          href="http://www.epicracepontevedra.com/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Epic Race Pontevedra
                        </a>
                      </Dropdown.Item>
                      <Dropdown.Item className="dropdown-item">
                        <a
                          className="Header-link"
                          href="http://www.pontevedra4picos.com/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Pontevedra 4 Picos
                        </a>
                      </Dropdown.Item>
                    </Dropdown.Submenu>
                  </Dropdown.Item>
                  <Dropdown.Item className="Header-link">
                    Pruebas amigas
                    <Dropdown.Submenu>
                      <Dropdown.Item className="dropdown-item">
                        <a
                          className="Header-link"
                          href="https://mountainquest.pt/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Mountain Quest
                        </a>
                      </Dropdown.Item>
                      <Dropdown.Item className="dropdown-item">
                        <a
                          className="Header-link"
                          href="https://dourobikerace.com/es/dbr/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Douro Bike Race
                        </a>
                      </Dropdown.Item>
                      <Dropdown.Item className="dropdown-item">
                        <a
                          className="Header-link"
                          href="https://www.gigantedepiedra.com/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Gigante de Piedra
                        </a>
                      </Dropdown.Item>
                      <Dropdown.Item className="dropdown-item">
                        <a
                          className="Header-link"
                          href="https://laleyendadetartessos.com/?gclid=Cj0KCQjwj5mpBhDJARIsAOVjBdpsPRMWA-5B5G-60b_h1lTRd9SXXZQAfr3fQStRnpdrHPlrYZrW5CEaAgV6EALw_wcB"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          La Leyenda de Tartesos
                        </a>
                      </Dropdown.Item>
                      <Dropdown.Item className="dropdown-item">
                        <a
                          className="Header-link"
                          href="https://www.amigosdamontanha.com/_maratona-btt-5-cumes"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Maratona 5 cumes
                        </a>
                      </Dropdown.Item>
                    </Dropdown.Submenu>
                  </Dropdown.Item>
                </Dropdown>
              </li>
              <li className="Header-item">
                <Link className="Header-link" to="/sponsors">
                  Sponsors
                </Link>
              </li>
              <li className="Header-item Header-item-check-inscription">
                <a
                  className="Header-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://sportmaniacs.com/es/check-inscription/pontevedra-4-picos-2025?event=676154d3-e860-49e0-b3c7-4627ac1f2fb7"
                >
                  Comprobar <br/> inscripción
                </a>
              </li>
              <li className="Header-item Header-item-inscription">
                <a
                  className="Header-link Header-link-inscription"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://sportmaniacs.com/es/services/inscription/costa-atlantica-mtb-2025-22958"
                >
                  <FormattedMessage
                    id="header.enroll"
                    defaultMessage="Inscríbete"
                  />
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </header>
    );
  }
}

export default Header;
